/**
 * @desc 获取 UA
 */
let uaResult = null
export const getUA = () => {
  if (!uaResult) {
    let ua = navigator.userAgent.toLowerCase()

    let mobileSafari = /iPhone|iPad|iPod/i.test(ua)
      && /iPhone|iPod|iPad/i.test(navigator.platform)
      && /Safari\/[\d\.]+$/i.test(ua)

    let iosVersion = 0
    var p = /iphone os ([0-9]+)_/i
    var matchResult = ua.match(p)
    if (matchResult && matchResult.length > 1) {
      iosVersion = parseInt(matchResult[1], 10)
    }

    let isPad = /iPad/i.test(ua)

    uaResult = {
      isPad: isPad,
      isSafari: mobileSafari,
      isIqiyi: /iqiyi/.test(ua),
      isBaidu: /baidu/.test(ua),
      isUCBrowser: /ucbrowser/.test(ua),
      isQQBrowser: /qqbrowser/.test(ua),
      isQQLiveBrowser: /qqlivebrowser/.test(ua),
      isWeixin: /micromessenger/.test(ua) || /weixin/.test(ua),
      isAndroid: /android/.test(ua),
      isIOS: /iphone/.test(ua) || /ipad/.test(ua) || /itouch/.test(ua) || /ipod/.test(ua),
      isFirefox: /firefox/.test(ua),
      isImgotv: /imgo/.test(ua),
      isBaiduBrowser: /baidubrowser/.test(ua),
      isChrome: /chrome/.test(ua),
      iosVersion: iosVersion,
      isWeibo: /weibo/.test(ua),
      isMobileQQ: /mqq/.test(ua) || /mobile\/.+qq\//.test(ua)
    }
  }
  return uaResult
}
